import React from "react";

const ChatManagment = () => {
  return <div>ChatManagment</div>;
};

export default ChatManagment;
